export default __webpack_public_path__ + "static/media/p3p.bedb550b.png";